module.exports = __webpack_public_path__ + "images/f51e6f2ff5601478ce30d58b726079ff-MSW_LineArt_PanelSwap_IQ5_PanelButton_Slide10.png";